module.exports = __webpack_public_path__ + "img/news14_1.ede03845.jpg";